// A rejected login credential is different from an invalid existing session.
export const SESSION_ERROR_CODES = [
  'TOKEN_EXPIRED', 'INVALID_TOKEN', 'AUTH_TOKEN_MISSING', 'ACCOUNT_INACTIVE',
  'SESSION_REVOKED', 'IMPERSONATION_REVOKED',
];

export const isSessionError = (error) => {
  const status = error.status || error.response?.status;
  // Axios adds its own transport code (ERR_BAD_REQUEST) to 401 responses.
  // Prefer the API's specific session code; authService's normalized Error
  // carries that same code directly and has no response object.
  const code = error.response?.data?.error?.code || error.code;
  return status === 401 && SESSION_ERROR_CODES.includes(code);
};
